// turn record path string into keyPath array ['tree', '1', 'children']
export const getKeyPath = (path) => [
  'tree',
  ...path
    .toLowerCase()
    .split('/')
    .slice(2),
]
